import React, { useRef, useEffect} from 'react';
import { CreditorTableStyle } from '../styles';
import { useSlideData } from '@context/slide-data';
import { useTranslation } from 'react-i18next';
import { handleScroll, updateRefScrollPosition } from '@utils/handleScroll';
import { usePresentation } from '@context/presentation';
import { retrieveScrollPosition } from '@utils/browserStorage';
import { SCROLL_IDS } from '@constants';
import { isValidNumber } from '@utils/validateInputs';
import { StyledTD } from './ToolTip';

export const CreditorTable = ({ creditorData, totalBalance, totalPayment, avgCreditUsage }) => {
    const { t } = useTranslation();
    const { desktop, slideState } = useSlideData();
    const { clientViewing } = usePresentation();
    const tableRef = useRef(null);
    const scrollId = SCROLL_IDS.creditorTable;
    const currentScrollPosition = slideState.scrollTop ? slideState.scrollTop[scrollId] : null;

    useEffect(() => {
        if (isValidNumber(currentScrollPosition) && clientViewing) {
            updateRefScrollPosition(tableRef, currentScrollPosition);
        }
    }, [tableRef, currentScrollPosition]);

    useEffect(() => {
        retrieveScrollPosition(scrollId, tableRef);
    }, [tableRef])

    return (
        <CreditorTableStyle desktop={desktop} clientViewing={clientViewing}>
            <thead>
                <tr>
                    <th>{t('your_analysis.creditor')}</th>
                    { desktop && <th>{t('your_analysis.account_holder')}</th>}
                    { desktop && <th className='text-right'>{t('your_analysis.percent_used')}</th>}
                    <th className='text-right'>{t('global.balance')}</th>
                    <th className='text-right'>{t('your_analysis.payments_due')}</th>
                </tr>
            </thead>
            <tbody 
                id={scrollId}
                ref={tableRef}
                onScroll={event => handleScroll(event, scrollId, clientViewing)} >
                {
                    creditorData.map((creditor, index) => {
                        return (
                            <tr key={index}>
                                <StyledTD content={creditor.Creditor}/>
                                { desktop && <td>{creditor.AccountHolder}</td>}
                                { desktop && <td className='text-right'>{creditor.PercentageUsed}</td>}
                                <td className='text-right'>{creditor.Balance}</td>
                                <td className='text-right'>{creditor.PaymentDue}</td>
                            </tr>
                        );
                    })
                }
            </tbody>
            <tfoot>
                <tr id='totals'>
                    <td colSpan={desktop ? '2' : '1'}>Total</td>
                    {desktop && <td className='text-right'>{avgCreditUsage}</td>}
                    <td className='text-right'>{totalBalance}</td>
                    <td className='text-right'>{totalPayment}</td>
                </tr>
            </tfoot>
        </CreditorTableStyle>
    );
};

export default CreditorTable;

